module.exports = __webpack_public_path__ + "img/xcx.877f8f48.png";